
import { WorldCountry } from '../types';
import { slovakiaExpanded } from './slovakiaExpansion';

export const finalEuropeCountries9: WorldCountry[] = [
  slovakiaExpanded
];
